module.exports = __webpack_public_path__ + "static/img/bear-sitting-on-a-laptop@2x.d4ea11c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/download/images/bear-sitting-on-a-laptop@2x.png
// module id = 1YkC
// module chunks = 26